import { Button, Modal } from "react-bootstrap";

export default function PushNotificationModal({ show,isChecked, handleClose,handleConfirm }) {

return (
    <Modal show={show} onHide={handleClose} centered size="sm" className="modal fade bs_common_modal push-notification-modal" >
          <Modal.Body>
    
            <Modal.Header closeButton>
                <h4 className="dialog-title">{ isChecked ? "Notification" : "Notification" }</h4>
            </Modal.Header>
            <div className="">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="dialog-content-body modalbody-form-filed">
                    <div className="dialog-content-text">
                      <h3>Are you sure you want to opt-{!isChecked? 'in':'out'} for SMS and email notifications?</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

           <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                    Cancel
            </Button>
            <Button variant="primary" onClick= {handleConfirm}>
                    Yes, {!isChecked? 'Enable':'Disable'}
            </Button>
        </Modal.Footer>
    </Modal>
);


}